import "./Input.css";
import { useState } from "react";
import { forwardRef } from "react";

const TextInput = forwardRef((props, ref) => {
    const prefixeClassName = "input";
    const [passwordShown, setPasswordShown] = useState(false);
    const togglePassword = () => {
        setPasswordShown(!passwordShown);
    };
    return (
        <>
            {props.type == "password" ? (
                <div style={{ display: "flex" }}>
                    <input
                        {...props}
                        ref={ref}
                        type={props.type == "password" ? (passwordShown ? "text" : "password") : props.type}
                        value={props.value}
                        className={
                            prefixeClassName +
                            (props.className ? " " + props.className : "") +
                            (props.type == "password" ? " input_auth" : "")
                        }></input>
                    <i
                        className={"icon_toggle_password " + (passwordShown ? "fas fa-eye-slash" : "fas fa-eye")}
                        onClick={() => togglePassword()}></i>
                </div>
            ) : (
                <input
                    {...props}
                    ref={ref}
                    className={prefixeClassName + (props.className ? " " + props.className : "")}></input>
            )}
        </>
    );
});

TextInput.defaultProps = {
    className: "full-width input-space",
    type: "text",
    autoComplete: "chrome-off",
};

export default TextInput;
